(function() {
    'use strict';

    angular
        .module('plagiat2017App')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope', '$injector', '$log'];

    function errorHandlerInterceptor ($q, $rootScope, $injector, $log) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if ((!response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('plagiat2017App.httpError', response);
                var $state = $injector.get('$state');
                $state.go('login');
            }
            return $q.reject(response);
        }
    }
})();
